module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2q"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")]), _vm._v(" / Samuel Schalkowsky")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/inside#ins"
    }
  }, [_c('em', [_vm._v("Inside the Kovno Ghetto")]), _vm._v(" / Samuel D. Kassow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HISTORY OF THE VILIAMPOLE [KOVNO] JEWISH GHETTO POLICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Prehistory of the Kovno Ghetto")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Weeks")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transfer to the Ghetto")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. The Gruesome Period from the Beginning of the Ghetto to the Great Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Days; Establishment of the Jewish Ghetto Police")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Personal Effects and Gold “Actions”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Development and Expansion of the Police Force")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Jordan Certificates” and the “Rehearsal Action”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Airfield and City Work Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Actions: In the “Box” (September 26, 1941) and in the “Small Ghetto” (October 4, 1941)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Episode” of the German Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Ghetto Situation after the Great Action (The survivor must live . . .)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Action: Moods and Rumors; Camp or Ghetto")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Labor Quota")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Material Conditions")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Events in the Ghetto after the Great Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. The Elder Council, the Ghetto Institutions, the Police, and the Ghetto Population: Mutual Interrelationships")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Development of the Administrative Apparatus and of the Police after the Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. The Ghetto Guard and the Jewish Police")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Ghetto Guard (NSKK) Located inside the Ghetto")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gate and the Gate Guard")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghetto Guard and the Police Intermediary (Relations with Germans and Lithuanians)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("8. The Ghetto during the Time of the NSKK, Wiedmann, and Hermann (Spring and Summer 1942)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jordan’s Last Actions (The Riga Action and the Book Action)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Departure of Jordan and Kaminski")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Masters, New Winds (Wiedmann, Hermann—German Labor Office)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evacuation of “Brazilke”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Workers for Palemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Labor Quota")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Economic Conditions; Gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vilna Letter Episode")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghetto Commissions")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("9. The Police in the Spring and Summer of 1942 (the Caspi Period)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Appearance of Caspi")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Caspi Personality")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Police Reforms and Reorganizations; New Management")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caspi’s Departure")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("10. The Ghetto in the Times of Koeppen, Miller, and the Vienna Protective Police (Schutz Polizei)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Economy without Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Days of Awe, Again Palemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vienozinskio Area Cleared Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riga a Second Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meck Episode")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assaults")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chanukah and the New Year—Beginning of the Ghetto Bright Period (the Time of Miller)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("11. The Police in the Last Quarter of 1942")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Units (Gate and Detention-House Guards; Jail and Workshop Guards)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expansion of the Administrative Work of the Police (Penal Department, Criminal Department, “Passportization,” Administrative Penalties)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Police as a Social Organization (the Swearing-in Ceremony, Police Concerts)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Evolution of the Manuscript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Maps appear on "), _c('a', {
    attrs: {
      "href": "#/xhtml/map#page_xviii"
    }
  }, [_vm._v("pages xviii")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/map01#page_xix"
    }
  }, [_vm._v("xix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Illustrations appear on "), _c('span', {
    attrs: {
      "href": "#/xhtml/illustrations#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 152")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/image03#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/illustrations01#page_246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/image08#page_252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/illustrations02#page_365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/appendix02#page_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("367")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0